import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
import clsx from "clsx";
import {
  sexCheck,
  smokingCheck,
  dmynCheck,
  hpynCheck,
  paCheck,
} from "../../../utils/cancerCalView";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 56,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
    },
  },
  title: {
    marginBottom: 18,
  },

  regular: {
    fontSize: 22,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 22,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  regular2: {
    fontWeight: 500,
  },
  bold: {
    fontWeight: 600,
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 120,
    [theme.breakpoints.down("md")]: {
      width: 100,
      paddingLeft: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 80,
    },
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
  },
  body: {
    marginTop: 24,
    marginBottom: 117,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 80,
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 12,
    },
  },
  bodybol: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    // marginTop: 32,
    // marginBottom: 32,
  },
  inputLine: {
    width: "50%",
    color: "#1a2633",
  },
  buttons: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      fontSize: 18,
      width: 80,
      height: 36,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  buttonBack: {
    width: 432,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  sex: {
    paddingRight: 6,
  },
  viewtitle: {
    color: "#60768e",
    fontSize: 23,
    [theme.breakpoints.down("md")]: {
      fontSize: 23,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 17,
    },
  },
  title1: {
    width: 65,
    color: "#60768e",
  },
  title2: {
    width: 220,
    color: "#60768e",
    [theme.breakpoints.down("md")]: {
      width: 220,
    },
    [theme.breakpoints.down("sm")]: {
      width: 164,
    },
  },
  half1: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "40%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(3.5),
    },
  },
  half2: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(3.5),
    },
  },
  content: {
    marginTop: 32,
    [theme.breakpoints.down("lg")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  footer: {
    marginTop: 12,
    marginBottom: 36,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
}));

const FormList = ({ score, data, onChange, onTotal }) => {
  const classes = useStyles();
  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid className={classes.info}>
          <Typography variant="h3">입력정보</Typography>
        </Grid>
        <Grid className={classes.infoLine}></Grid>
      </Grid>
      <Grid
        container
        className={classes.body}
        justify="space-between"
        alignItems="center"
        direction="column"
      >
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Grid className={classes.half1}>
            <Grid container>
              <Typography variant="h4">
                <span className={clsx(classes.bold, classes.viewtitle)}>
                  기본정보
                </span>
              </Typography>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>성별</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {sexCheck(data.sex)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>연령</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.age} 세</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>신장</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.cm} cm</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>체중</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.kg} kg</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.half2}>
            <Grid container>
              <Typography variant="h4">
                <span className={clsx(classes.bold, classes.viewtitle)}>
                  병력 및 생활습관 정보
                </span>
              </Typography>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>당뇨</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {dmynCheck(data.dmyn)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>고혈압</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {hpynCheck(data.hpyn)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>규칙적 운동</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {paCheck(data.pa)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>흡연기간/하루흡연량</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {smokingCheck(
                        data.smoking,
                        data.smokingGap,
                        data.gapYear
                      )}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormList;
